import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=6e49870a&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=ts"
export * from "./UserView.vue?vue&type=script&lang=ts"
import style0 from "./UserView.vue?vue&type=style&index=0&id=6e49870a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e49870a",
  null
  
)

export default component.exports